import { StationDetailBaseViewmodel } from "@station/presentation/components/detail/station-detail-base.viewmodel.ts";
import { injectFromBase, injectable } from "inversify";

@injectable()
@injectFromBase()
export class StationDetailViewmodel extends StationDetailBaseViewmodel {}
